import { ruLocale__SkillsChart } from "../../common/skills-chart/locales";
import { ruLocale__RightSwitcher } from "../../modules/sunday-top-nav/buttons/right-toggle/locales";
import { ruLocale__Navigation } from "../../routes/locales";
import { MergeTranslateKeys } from "../keys";

const messages: MergeTranslateKeys = {
    cardAbout_label: 'О себе',
    ...ruLocale__SkillsChart,
    ...ruLocale__RightSwitcher,
    ...ruLocale__Navigation
}

export default messages;